export default __webpack_public_path__ + "static/media/yooo.8927c105.mp3";